<template>
  <div class="home">
    <div v-if="!pwaInstalled">
      <!-- MAIN HEADER  -->
      <header>
        <div class="header-container">
          <div>
            <h1 class="title">{{ $t("0-click send via mail to yourself") }}</h1>
          </div>
          <div>
            <h2 class="subtitle">
              <b>"{{ $t("Share with") }} > Mail2Self"</b>
              {{ $t("from any app") }}
            </h2>
            <h3 class="subtitle">
              {{ $t("and you'll get what you shared as an email") }}
            </h3>
          </div>

          <div>
            <InstallPWA />
          </div>
        </div>

        <a class="scroll-down" href="#more-home"></a>
      </header>
      <!-- INSTRUCTIONS -->
      <a name="more-home">
        <Instructions />
      </a>
    </div>
    <div v-else>
      <!-- IF ALREADY INSTALLED -->
      <InstallPWA style="margin-top: 60px; margin-bottom: 30px;" />
      <div v-if="pwaInstalled && loggedIn">
        <p class="alert alert-warning">
          {{ $t("sending mails to") }} <b>{{ userData.email }}</b>
        </p>
      </div>
      <InstalledInstructions />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import InstallPWA from "@/components/InstallPWA.vue";
import Instructions from "@/components/Instructions.vue";
import InstalledInstructions from "@/components/InstalledInstructions.vue";
import { closeMe } from "@/utils";

export default {
  name: "Home",

  components: {
    InstallPWA,
    Instructions,
    InstalledInstructions,
  },

  data() {
    return {};
  },

  computed: {
    ...mapState("userData", ["loggedIn", "user", "userData"]),
    ...mapState("installPWA", ["pwaInstalled"]),
  },

  methods: {},

  mounted() {},
};
</script>

<style lang="scss" scoped>
.header-container {
  height: calc(70% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

@media (min-width: 961px) {
  .alert {
    margin-left: auto;
    margin-right: auto;
    max-width: 30%;
    border-radius: 50px;
  }
}
</style>
